import React, { useState } from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import {
    Nav,
    Bars,
    NavMenu,
    NavMenu2,
    NavRight,
} from './NavbarElements';
import { useDispatch } from 'react-redux';
import { loginBid } from '../../redux/action';

const Navbar = () => {
    const [showMobile, setShowMobile] = useState(false);
    const dispatch = useDispatch();

    const LogOut = () => {
        dispatch(loginBid([]));
        localStorage.clear();
        localStorage.removeItem('fleetId');
        localStorage.removeItem('token');
        window.location.reload();
    };

    return (
        <>
            <Nav>
                <Bars className='bar' onClick={() => setShowMobile(!showMobile)} />
                <NavMenu>
                    <NavRight>
                        <button type='button' onClick={LogOut} className='logoutCl' aria-label='Çıxmaq'>
                            <FaSignOutAlt />
                            <span>Çıxmaq</span>
                        </button>
                    </NavRight>
                </NavMenu>
                {showMobile && (
                    <NavMenu2>
                        <button type='button' onClick={LogOut} className='logoutCl logoutClMobile' aria-label='Çıxmaq'>
                            <FaSignOutAlt />
                            <span>Çıxmaq</span>
                        </button>
                    </NavMenu2>
                )}
            </Nav>
        </>
    );
};

export default Navbar;
